import React, { useState, useEffect } from 'react';
// import './blogs-page.css';
import 'react-multi-carousel/lib/styles.css';
import moment from 'jalali-moment'

// svgs
import { TabPanel, TabView } from 'primereact/tabview';
import { Col } from 'react-bootstrap';
import SecondaryBanner from '../banner/secondary-banner';
import { getBlogById, imgBaseUrl } from '../../utils/api';
import Calendar from '../../assets/icons/calendar.svg';
import Time from '../../assets/icons/time.svg';
import { useLocation } from "react-router-dom";
import Loader from '../../components/loader/dotloader'

const Products = () => {
  const location = useLocation();
  const [blog, setBlog] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchProduct = async () => {
      try {
        setLoading(true)
        const queryParams = new URLSearchParams(location.search);
        const id = queryParams.get("id");
        const res = await getBlogById(id);
        if (res.data.isSuccess) {
          setBlog(res.data.data);
          setLoading(false)
        }
      } catch (error) {
        setLoading(false)
        console.error('Error fetching product:', error);
      }
    };
    fetchProduct();
  }, [location]);
  const jalaliDate = (date) => {
    console.log(date)
    let persianDate = moment(date, 'YYYY-MM-DDTHH:mm:ss')
      .locale('fa') // Set locale to Persian
      .format('DD MMMM YYYY');
    return persianDate
  }
  return (
    <div>
      {loading && <Loader isLoading={loading} />}

      {/* <SecondaryBanner slug='blogs1' /> */}
      <section className="position-relative container">
        <div className="blogs-item border-0 mt-5" >
          <div className='d-flex align-items-start justify-content-start gap-3 row'>
            <div className='img-box col-md-4 col-sm-12' >
            <img src={imgBaseUrl + blog.logoPath} className="img-product" alt="Blog Image" />

            </div>
            <div className='col-md-4 col-sm-12' >
              <h1>{blog.summery}</h1>
              <div className="d-flex align-items-start justify-content-start gap-3 flex-mob-col">
                <div className="d-flex align-items-center gap-3">
                  <img src={Calendar} alt="Calendar icon" />
                  <h6>{blog.createDate ? jalaliDate(blog.createDate) : ''}</h6>
                </div>
                <div className="d-flex align-items-center gap-3">
                  <img src={Time} alt="Time icon" />
                  <h6>{blog.readTime} دقیقه زمان مطالعه</h6>
                </div>
              </div>
            </div>
          </div>


          <div className='mt-5' dangerouslySetInnerHTML={{ __html: blog.body }} />
        </div>
      </section>
    </div>
  );
};

export default Products;
